export default __webpack_public_path__ + "static/media/healthscan-not-found-illustration.4e332a85.svg";